import { createTheme } from '@mui/material/styles'
import { baseTheme } from './baseTheme'

export const darkTheme = createTheme({
  ...baseTheme,
  ...{
    palette: {
      background: {
        primary: '#161616',
        secondary: '#262626',
        terciary: '#393939',
        disabled: '#393939',
        dark: '#FFFFFF'
      },

      button: {
        hover: '#262626'
      },

      text: {
        primary: '#F4F4F4',
        secondary: '#A8A8A8',
        terciary: '#525252',
        light: '#FFFFFF'
      },

      primary: {
        light: '#66B2AF',
        main: '#007E7A',
        dark: '#013B3A'
      },

      secondary: {
        light: '#FFEEC1',
        main: '#F9B811',
        dark: '#D9860A'
      },

      error: {
        main: '#DA1E28',
        dark: '#750E13',
        light: '#FF8389'
      },

      success: {
        main: '#3EA515',
        dark: '#2D8709',
        light: '#90D758'
      },

      warning: {
        main: '#E99A17',
        dark: '#C68200',
        light: '#F8CC2F'
      },

      border: {
        primary: '#393939',
        secondary: '#525252 ',
        terciary: '#6F6F6F'
      },

      overlay: 'rgba(255, 255, 255, 0.1)',

      typeColor: {
        primary: '#E0E0E0',
        secondary: '#FFFFFF',
        terciary: '#525252',
        light: '#FFFFFF'
      },

      gray: {
        primary: '#E0E0E0',
        secondary: '#E0E0E0'
      },

      teal: {
        hover: '#AAF0E8',
        select: '#78E0D4',
        primary: '#00605B'
      },

      yellow: {
        hover: '#FFE39C',
        select: '#FFD874',
        primary: '#D9860A'
      },

      red: {
        hover: '#FFC0C0',
        select: '#FF8585',
        primary: '#9E0101'
      },

      green: {
        hover: '#DEFFCE',
        select: '#B8FF96',
        primary: '#319204'
      }
    }
  }
})
